import type { GameConfig } from "../config/GameConfig";
import { deepMergeInto } from "../config/persist";
import { limenLevel } from "./limen";
import { oniryaLevel } from "./onirya";
import type { Level } from "./types";

export type { ExtraRule, Level, LevelAudio, LevelCopy, LevelObject, LevelRules, WorldPatch } from "./types";

export const LEVELS: Record<string, Level> = {
  [oniryaLevel.id]: oniryaLevel,
  [limenLevel.id]: limenLevel,
};

export const LEVEL_ORDER: string[] = [oniryaLevel.id, limenLevel.id];

/** Nível por omissão. `?level=limen` escolhe outro. */
export const ACTIVE_LEVEL_ID = oniryaLevel.id;

export function getActiveLevel(): Level {
  const wanted = new URLSearchParams(location.search).get("level") ?? ACTIVE_LEVEL_ID;
  const level = LEVELS[wanted] ?? LEVELS[ACTIVE_LEVEL_ID];
  if (!level) throw new Error(`Nível desconhecido: ${wanted}`);
  return level;
}

/**
 * Recorte de identidade deste nível (forma, score, áudio, …).
 * Corre depois de `resetConfig` e antes do JSON `defaults/{id}.json`.
 */
export function applyLevel(config: GameConfig, level: Level): void {
  if (level.world) deepMergeInto(config, level.world);
  if (level.rules.score.type === "meet-opposite") {
    config.score.meetMode = "opposite";
    config.score.oppositeErrorDeg = level.rules.score.maxErrorDeg;
  } else if (level.rules.score.type === "meet-pair") {
    config.score.meetMode = "pair";
  }
  if (level.audio.bed === "synth-am" || level.audio.bed === "synth-pass") {
    config.audio.bedId = level.audio.bed;
  }
  if (level.rules.lose.type === "region-share" || level.rules.lose.type === "divider-or-region") {
    config.divider.spaceLoseAt = level.rules.lose.fraction;
  }
}
